import { render, staticRenderFns } from "./TypeCompoundForm.vue?vue&type=template&id=42433790&"
import script from "./TypeCompoundForm.vue?vue&type=script&lang=js&"
export * from "./TypeCompoundForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports